import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Award } from '../../models/award.school.model';
import { awardAdapter, AwardState } from '../reducers/award.school.reducer';
import { selectRouteParams } from './router.selector';

export const getAwardState = createFeatureSelector<AwardState>('awards');
export const getIds = (state: AwardState) => state.ids;

export const {
  selectIds: getAwardIds,
  selectEntities: getAwardEntities,
  selectAll: getAllAwards,
  selectTotal: getTotalAwards,
} = awardAdapter.getSelectors(getAwardState);

export const loading = createSelector(
  getAwardState,
  (awardState: AwardState) => awardState.loading
);

export const inProgress = createSelector(
  getAwardState,
  (awardState: AwardState) => awardState.inProgress
);

export const hasMore = createSelector(
  getAwardState,
  (awardState: AwardState) => awardState.hasMore,
);

// export const getAwardsBySelectedGroup = createSelector(
//   getAllAwards,
//   selectRouteParams,
//   (allItems, { id }) => {
//     if (allItems) {
//       return allItems.filter((item) => {
//         return item.groupId === id;
//       });
//     } else {
//       return null;
//     }
//   }
// );

// export const getAwardsCountForSelectedGroup = createSelector(
//   getAllAwards,
//   selectRouteParams,
//   (allItems, { id }) => {
//     return allItems.filter((item) => {
//       return item.groupId === id;
//     }).length;
//   }
// );

export const getAwardById = (awardId: string) =>
  createSelector(getAllAwards, selectRouteParams, (allItems, { id }) => {
    if (allItems) {
      return allItems.find((item) => {
        return item.groupId === id && item.id == awardId;
      });
    } else {
      return null;
    }
  });

export const getAwardsByStudentId = (studentId: string | undefined) =>
  createSelector(getAllAwards, selectRouteParams, (allItems, { id }) => {
    if (!studentId) return [];
    return allItems
      .filter((item) => {
        return item.groupId === id && item.studentId === studentId;
      })
      .sort(sortDescendingByModifiedDate);
  });

export const getAllAwardsByStudentId = (studentId: string | undefined) =>
  createSelector(getAllAwards, (allItems) => {
    if (!studentId) return [];
    return allItems
      .filter((item) => {
        return item.studentId === studentId;
      })
      .sort(sortDescendingByModifiedDate);
  });

// export const getAwardsBySelectedGrade = createSelector(
//   getAllAwards,
//   selectRouteParams,
//   (allItems, { id, studentId }) => {
//     return allItems
//       .filter((item) => {
//         return item.groupId === id && item.studentId === studentId;
//       })
//       .sort(sortDescendingByCreatedDate);
//   }
// );

function sortDescendingByCreatedDate(a: Award, b: Award): number {
  return a.created! > b.created! ? -1 : a.created! < b.created! ? 1 : 0;
}

function sortDescendingByModifiedDate(a: Award, b: Award): number {
  const dateA = a.modified ? a.modified.toMillis() : (a.created ? a.created.toMillis() : 0);
  const dateB = b.modified ? b.modified.toMillis() : (b.created ? b.created.toMillis() : 0);
  return dateB - dateA;
}
